/**
 * @fileoverview UI module with nested sub-modules for loading, toast, and confirm.
 */

import {
  createBreadcrumbsSubModule,
  createLoadingSubModule,
  createToastSubModule,
  createConfirmFunction,
} from "./components";
import type { UIModule } from "./types";

export type {
  UIModule,
  LoadingSubModule,
  BreadcrumbsSubModule,
  ToastSubModule,
  LoadingMode,
  ToastOptions,
  ToastType,
} from "./types";

/**
 * Create the UI module with nested sub-modules.
 *
 * @returns UI module instance
 */
export function createUIModule(): UIModule {
  return {
    loading: createLoadingSubModule(),
    breadcrumbs: createBreadcrumbsSubModule(),
    toast: createToastSubModule(),
    confirm: createConfirmFunction(),
  };
}
